import Vue from 'vue';
import Vuex from 'vuex';
import ux from '@/store/ux';
import FirebaseSnapshots from '@/shared/firebase/firebaseSnapshots';
import {
  MUTATION_REGISTER_SNAPSHOT_LISTENER,
  MUTATION_UNREGISTER_SNAPSHOT_LISTENER,
} from '@/shared/store/constants';
import analyses from '@/shared/store/analyses';
import analysesCapture from '@/shared/store/analysesCapture';
import user from '@/shared/store/user';
import users from '@/shared/store/users';
import crud from '@/shared/store/crud';
import aclEditor from '@/shared/store/aclEditor';
import notifications from '@/shared/store/notifications';
import tags from '@/shared/store/tags';
import portfolio from '@/shared/store/portfolio';
import portfolioV2 from '@/shared/store/portfolioV2';
import authentication from '@/shared/store/authentication';
import featureSwitches from '@/shared/store/featureSwitches';
import globalConfig from '@/shared/store/globalConfig';
import analysisVotes from '@/shared/store/analysisVotes';
import missions from '@/shared/store/missions';
import upload from '@/shared/store/upload';
import templates from '@/shared/store/templates';
import bibliography from '@/shared/store/bibliography';
import sources from './store/sources';
import display from './store/display';
import reflections from './store/reflections';
import {
  ACTION_HANDLE_OPERATION_COMPLETION,
  ACTION_UNSUBSCRIBE_SNAPSHOT_LISTENERS,
  MUTATION_SHOW_SNACKBAR,
  MUTATION_HIDE_SNACKBAR,
  GETTER_FIREBASE_PROJECT_ID,
  GETTER_VERSION,
} from './store/rootTypes';
import recommendationBasedJournals from './store/recommendationBasedJournals';
import { firebaseConfig } from './firebaseConfig';
import { currentVersion } from './tools/currentVersion';

Vue.use(Vuex);

const initialState = {
  firebaseSnapshots: new FirebaseSnapshots(),
  showSnackbar: false,
  snackbarColor: 'success',
  snackbarMessage: '',
};

const mutations = {
  [MUTATION_SHOW_SNACKBAR]: (state, { message, color }) => {
    state.snackbarMessage = message;
    state.snackbarColor = color;
    state.showSnackbar = true;
  },
  [MUTATION_HIDE_SNACKBAR]: state => {
    state.showSnackbar = false;
    state.snackbarMessage = '';
  },
  [MUTATION_REGISTER_SNAPSHOT_LISTENER]: (state, { snapshotListener, id }) => {
    state.firebaseSnapshots.register(snapshotListener, id);
  },
  [MUTATION_UNREGISTER_SNAPSHOT_LISTENER]: (state, { id }) => {
    state.firebaseSnapshots.unregister(id);
  },
};

const actions = {
  [ACTION_HANDLE_OPERATION_COMPLETION]: ({ commit }, { message, color }) => {
    commit(MUTATION_SHOW_SNACKBAR, { message, color });
  },
  [ACTION_UNSUBSCRIBE_SNAPSHOT_LISTENERS]: ({ rootState }) => {
    rootState.firebaseSnapshots.unsubscribeAll();
  },
};

const getters = {
  [GETTER_FIREBASE_PROJECT_ID]: () => firebaseConfig.projectId,
  [GETTER_VERSION]: () => currentVersion(),
};

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: initialState,
  getters,
  actions,
  mutations,
  modules: {
    authentication,
    analyses,
    analysesCapture,
    portfolio,
    portfolioV2,
    user,
    users,
    crud,
    aclEditor,
    ux,
    notifications,
    tags,
    sources,
    display,
    featureSwitches,
    globalConfig,
    analysisVotes,
    missions,
    upload,
    recommendationBasedJournals,
    reflections,
    templates,
    bibliography,
  },
});

window.noos_frontendv2_store = store;
export default store;
